import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {IRootState} from "./configureStore";
import {IFile} from "./sliceFiles";

export interface ITab {
  files: boolean;
  cameras: boolean;
  home: boolean;
  loading: boolean
  progressBar: number
  bar: boolean
  contextBackground: boolean
}

export const initialState: ITab = {
  files: true,
  cameras: false,
  home: false,
  loading: false,
  progressBar: 0,
  bar: false,
  contextBackground: false
};


const slice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setFiles: (state: IRootState) => {
      state.files = true
      state.cameras = false
      state.home = false
    },
    setCameras: (state: IRootState) => {
      state.files = false
      state.cameras = true
      state.home = false
    },
    setHome: (state: IRootState) => {
      state.files = false
      state.cameras = false
      state.home = true
    },
    clearAll: (state: IRootState) => {
      state.files = false
      state.cameras = false
      state.home = false
    },
    showLoading: (state: IRootState) => {
      state.loading = true
    },
    hideLoading: (state: IRootState) => {
      state.loading = false
      state.bar = false
      state.progressBar = 0
    },
    showProgressBar: (state: IRootState, action: PayloadAction<boolean>) => {
      state.bar = action.payload
      state.progressBar = 0
    },
    setProgressBarValue: (state: IRootState, action: PayloadAction<number>) => {
      state.progressBar = action.payload
    },
    setContextBackground: (state: IRootState, action: PayloadAction<boolean>) => {
      state.contextBackground = action.payload
    }
  },
});

const { actions, reducer } = slice;

export { actions, reducer };
